// enum of all chegg-web cookie keys
export var CookieName = /*#__PURE__*/function (CookieName) {
  CookieName["ACCESS_TOKEN"] = "access_token";
  CookieName["AL_CELL"] = "alCell";
  CookieName["CHAT_PARADIGM"] = "chat_paradigm";
  CookieName["CLOUDFRONT_COUNTRY_CODE"] = "country_code";
  CookieName["COUPON_CAMPAIGN"] = "coupon_campaign";
  CookieName["COUPON_CODE"] = "applied_coupon_code";
  CookieName["C_SESSION_ID"] = "CSessionID";
  CookieName["CSID"] = "CSID";
  CookieName["CVID"] = "CVID";
  CookieName["DFID"] = "DFID";
  CookieName["EC_UPLOAD_PENDING"] = "ec_upload_pending";
  CookieName["ENABLE_CL_SANDBOX"] = "enable-cl-sandbox";
  CookieName["EXP_AA"] = "chegg_web_cbr_aa_experiment";
  CookieName["EXP_AI_TOGGLE"] = "ai_toggle_exp";
  CookieName["EXP_MTC"] = "chegg_web_cbr_exp_mtc";
  CookieName["EXP_MTC_DEBUG_TOOL"] = "chegg_web_mtc_debug_tool";
  CookieName["EXP_MTC_SKIP_SEARCH"] = "chegg_web_mtc_skip_search";
  CookieName["EXP_OPT_IN"] = "chegg_web_cbr_exp_opt_in";
  CookieName["EXP_RAG_SOLUTION"] = "chegg_web_cbr_exp_rag_solution";
  CookieName["EXP_UAE"] = "chegg_web_cbr_exp_uae";
  CookieName["EXPERIMENT"] = "exp";
  CookieName["EXPERIMENT_IDENTIFIER"] = "V";
  CookieName["EXPERT_SOLUTIONS_ON_CONTENT_EXP"] = "expert-solutions-on-content-exp";
  CookieName["FORTER_TOKEN"] = "forterToken";
  CookieName["GEOLOCATION"] = "user_geo_location";
  CookieName["HIDE_DESKTOP_TO_APP_UIC_MODAL"] = "hide_desktop_to_app_uic_modal";
  CookieName["HIDE_GET_APP_CTA"] = "hide_get_app_cta";
  CookieName["HIDE_MWEB_TO_APP_SIGNIN_MODAL"] = "hide_mweb_to_app_signin_modal";
  CookieName["HIDE_RATING_PROMOTION_TOOLTIP"] = "hide_rating_promotion_tooltip";
  CookieName["HONOR_CODE_OPT_IN"] = "honor_code_opt_in";
  CookieName["HWH_ID"] = "hwh_id";
  CookieName["HWH_KEY"] = "hwh_key";
  CookieName["ID_TOKEN"] = "id_token";
  CookieName["IS_NEW_lOGIN_MWEB_TO_APP_EXPANSION_MODAL"] = "is_new_login_mweb_to_app_expansion_modal";
  CookieName["JERICHO_SESSION"] = "PHPSESSID";
  CookieName["LANG_PREFERENCE"] = "langPreference";
  CookieName["LAST_ACCESSED_SUBJECT"] = "last_accessed_subject";
  CookieName["MATH_MODE_TOOLTIP"] = "math_mode_tooltip";
  CookieName["MATH_PROBLEM_TOOLTIP"] = "math_problem_tooltip";
  CookieName["MULTIPLE_IMAGE_TOOLTIP"] = "multiple_image_tooltip";
  CookieName["OPT_USER_PROFILE"] = "opt-user-profile";
  CookieName["ORDER_REDIRECT"] = "hwh_order_ref";
  CookieName["PREVIOUS_TRUEX"] = "sbm_previous_truex_gcs";
  CookieName["QA_AUDIENCE"] = "qa_audience";
  CookieName["REWORKED_SEARCH_EXP"] = "reworked-search-exp";
  CookieName["U"] = "U";
  return CookieName;
}({});